export const DEFAULT_CURRENCY = 'GBP';

export const SUPPORTED_CURRENCIES = [
  'GBP',
  'USD',
  'EUR',
  'AED',
  'SAR',
  'QAR',
  'KWD',
  'BHD',
  'OMR',
  'JOD',
  'EGP',
  'MAD',
  'TND',
  'DZD',
  'IQD',
  'LYD',
  'LBP',
  'NGN',
  'CAD',
  'AUD',
  'INR',
  'JPY',
  'CHF',
  'CNY',
  'PKR',
  'BDT',
  'LKR',
  'PHP',
  'THB',
  'MYR',
  'SGD',
  'IDR',
  'VND',
  'ZAR',
  'KES',
  'GHS',
  'TZS',
  'TRY',
  'RUB',
  'KRW',
  'BRL',
  'MXN',
  'ARS',
  'NZD',
  'SEK',
  'NOK',
  'DKK',
  'PLN',
  'CZK',
  'HUF',
  'RON',
  'ILS',
  'TWD',
  'HKD',
  'ETB',
  'XOF',
];

export const FALLBACK_RATES = {
  GBP: 1,
  USD: 1.27,
  EUR: 1.17,
  AED: 4.66,
  SAR: 4.76,
  QAR: 4.62,
  KWD: 0.39,
  BHD: 0.48,
  OMR: 0.49,
  JOD: 0.9,
  EGP: 62.0,
  MAD: 12.7,
  TND: 3.95,
  DZD: 170.0,
  IQD: 1660.0,
  LYD: 6.3,
  LBP: 113000.0,
  NGN: 1690,
  CAD: 1.73,
  AUD: 1.95,
  INR: 106.0,
  JPY: 198.0,
  CHF: 1.12,
  CNY: 9.2,
  PKR: 365.0,
  BDT: 145.0,
  LKR: 390.0,
  PHP: 70.0,
  THB: 45.0,
  MYR: 5.65,
  SGD: 1.69,
  IDR: 20000.0,
  VND: 32000.0,
  ZAR: 23.5,
  KES: 195.0,
  GHS: 16.5,
  TZS: 3300.0,
  TRY: 42.0,
  RUB: 115.0,
  KRW: 1720.0,
  BRL: 6.35,
  MXN: 22.5,
  ARS: 1200.0,
  NZD: 2.1,
  SEK: 13.4,
  NOK: 13.9,
  DKK: 8.65,
  PLN: 5.0,
  CZK: 29.0,
  HUF: 460.0,
  RON: 5.75,
  ILS: 4.65,
  TWD: 40.5,
  HKD: 9.85,
  ETB: 175.0,
  XOF: 765.0,
};

export const CURRENCY_STORAGE_KEY = 'tourasco_selected_currency_v1';

/** ISO 3166-1 alpha-2 → primary display/booking currency for that traveller. */
export const NATIONALITY_TO_CURRENCY = {
  GB: 'GBP',
  US: 'USD',
  CA: 'CAD',
  AU: 'AUD',
  NZ: 'NZD',
  IN: 'INR',
  PK: 'PKR',
  BD: 'BDT',
  LK: 'LKR',
  NP: 'INR',
  PH: 'PHP',
  TH: 'THB',
  MY: 'MYR',
  SG: 'SGD',
  ID: 'IDR',
  VN: 'VND',
  CN: 'CNY',
  JP: 'JPY',
  KR: 'KRW',
  TW: 'TWD',
  HK: 'HKD',
  AE: 'AED',
  SA: 'SAR',
  QA: 'QAR',
  KW: 'KWD',
  BH: 'BHD',
  OM: 'OMR',
  YE: 'SAR',
  EG: 'EGP',
  MA: 'MAD',
  TN: 'TND',
  DZ: 'DZD',
  LY: 'LYD',
  SD: 'EGP',
  IQ: 'IQD',
  JO: 'JOD',
  LB: 'LBP',
  SY: 'USD',
  PS: 'ILS',
  IL: 'ILS',
  TR: 'TRY',
  IR: 'USD',
  NG: 'NGN',
  ZA: 'ZAR',
  KE: 'KES',
  GH: 'GHS',
  TZ: 'TZS',
  ET: 'ETB',
  SN: 'XOF',
  CI: 'XOF',
  RU: 'RUB',
  BR: 'BRL',
  MX: 'MXN',
  AR: 'ARS',
  DE: 'EUR',
  FR: 'EUR',
  IT: 'EUR',
  ES: 'EUR',
  NL: 'EUR',
  IE: 'EUR',
  BE: 'EUR',
  AT: 'EUR',
  PT: 'EUR',
  IE: 'EUR',
  FI: 'EUR',
  GR: 'EUR',
  FI: 'EUR',
  PL: 'PLN',
  CZ: 'CZK',
  HU: 'HUF',
  RO: 'RON',
  SE: 'SEK',
  NO: 'NOK',
  DK: 'DKK',
  CH: 'CHF',
  LU: 'EUR',
  SK: 'EUR',
  SI: 'EUR',
  CY: 'EUR',
  HR: 'EUR',
  MT: 'EUR',
};

/**
 * Dropdown list: code = API nationality (ISO 2-letter), label = English name.
 * Order: UK/US/IE, Europe, MENA/Gulf, Africa, Asia, Americas.
 */
export const NATIONALITY_OPTIONS = [
  { code: 'GB', label: 'United Kingdom' },
  { code: 'US', label: 'United States' },
  { code: 'IE', label: 'Ireland' },
  { code: 'DE', label: 'Germany' },
  { code: 'FR', label: 'France' },
  { code: 'IT', label: 'Italy' },
  { code: 'ES', label: 'Spain' },
  { code: 'NL', label: 'Netherlands' },
  { code: 'BE', label: 'Belgium' },
  { code: 'CH', label: 'Switzerland' },
  { code: 'AT', label: 'Austria' },
  { code: 'PT', label: 'Portugal' },
  { code: 'PL', label: 'Poland' },
  { code: 'SE', label: 'Sweden' },
  { code: 'NO', label: 'Norway' },
  { code: 'DK', label: 'Denmark' },
  { code: 'FI', label: 'Finland' },
  { code: 'GR', label: 'Greece' },
  { code: 'CZ', label: 'Czech Republic' },
  { code: 'HU', label: 'Hungary' },
  { code: 'RO', label: 'Romania' },
  { code: 'LU', label: 'Luxembourg' },
  { code: 'SK', label: 'Slovakia' },
  { code: 'SI', label: 'Slovenia' },
  { code: 'CY', label: 'Cyprus' },
  { code: 'HR', label: 'Croatia' },
  { code: 'MT', label: 'Malta' },
  { code: 'RU', label: 'Russia' },
  { code: 'TR', label: 'Turkey' },
  { code: 'IL', label: 'Israel' },
  { code: 'PS', label: 'Palestine' },
  { code: 'JO', label: 'Jordan' },
  { code: 'LB', label: 'Lebanon' },
  { code: 'SY', label: 'Syria' },
  { code: 'IQ', label: 'Iraq' },
  { code: 'IR', label: 'Iran' },
  { code: 'EG', label: 'Egypt' },
  { code: 'MA', label: 'Morocco' },
  { code: 'DZ', label: 'Algeria' },
  { code: 'TN', label: 'Tunisia' },
  { code: 'LY', label: 'Libya' },
  { code: 'SD', label: 'Sudan' },
  { code: 'AE', label: 'United Arab Emirates' },
  { code: 'SA', label: 'Saudi Arabia' },
  { code: 'QA', label: 'Qatar' },
  { code: 'KW', label: 'Kuwait' },
  { code: 'BH', label: 'Bahrain' },
  { code: 'OM', label: 'Oman' },
  { code: 'YE', label: 'Yemen' },
  { code: 'NG', label: 'Nigeria' },
  { code: 'ZA', label: 'South Africa' },
  { code: 'KE', label: 'Kenya' },
  { code: 'GH', label: 'Ghana' },
  { code: 'TZ', label: 'Tanzania' },
  { code: 'ET', label: 'Ethiopia' },
  { code: 'SN', label: 'Senegal' },
  { code: 'CI', label: "Côte d'Ivoire" },
  { code: 'IN', label: 'India' },
  { code: 'PK', label: 'Pakistan' },
  { code: 'BD', label: 'Bangladesh' },
  { code: 'LK', label: 'Sri Lanka' },
  { code: 'NP', label: 'Nepal' },
  { code: 'CN', label: 'China' },
  { code: 'JP', label: 'Japan' },
  { code: 'KR', label: 'South Korea' },
  { code: 'TH', label: 'Thailand' },
  { code: 'MY', label: 'Malaysia' },
  { code: 'SG', label: 'Singapore' },
  { code: 'ID', label: 'Indonesia' },
  { code: 'PH', label: 'Philippines' },
  { code: 'VN', label: 'Vietnam' },
  { code: 'HK', label: 'Hong Kong' },
  { code: 'TW', label: 'Taiwan' },
  { code: 'CA', label: 'Canada' },
  { code: 'AU', label: 'Australia' },
  { code: 'NZ', label: 'New Zealand' },
  { code: 'BR', label: 'Brazil' },
  { code: 'MX', label: 'Mexico' },
  { code: 'AR', label: 'Argentina' },
];

export const normalizeCurrencyCode = (value) => {
  const code = (value || '').toString().trim().toUpperCase();
  return SUPPORTED_CURRENCIES.includes(code) ? code : DEFAULT_CURRENCY;
};

export const getCurrencyForNationality = (nationalityCode) => {
  const code = (nationalityCode || '').toString().trim().toUpperCase();
  return normalizeCurrencyCode(NATIONALITY_TO_CURRENCY[code] || DEFAULT_CURRENCY);
};

export const convertAmount = (amount, fromCurrency, toCurrency, rates) => {
  const numeric = Number(amount);
  if (!Number.isFinite(numeric)) return 0;

  const from = normalizeCurrencyCode(fromCurrency);
  const to = normalizeCurrencyCode(toCurrency);
  if (from === to) return numeric;

  const normalizedRates = rates || FALLBACK_RATES;
  const fromRate = Number(normalizedRates[from]) || 1;
  const toRate = Number(normalizedRates[to]) || 1;

  return (numeric / fromRate) * toRate;
};

export const formatCurrency = (amount, currencyCode) => {
  const code = normalizeCurrencyCode(currencyCode);
  const numeric = Number(amount);
  const safeAmount = Number.isFinite(numeric) ? numeric : 0;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: code,
    maximumFractionDigits: 2,
  }).format(safeAmount);
};
